export const loginAr = {
  "Username": "إسم المستخدم",
  "Password": "كلمة السر",
  "Connecter": "اتصال",
  "Wrong Data !": "بيانات خاطئة!",
  "Wrong Data !!": "بيانات خاطئة!!",
  "Gestion & Administration": "الإدارة والتسيير",
  "Espace Médecins": "مساحة الأطباء",
  "retourner à la page d'accueil": "العودة إلى الصفحة الرئيسية",
}